<template>
  <div class="cr-page">
    <header class="cr-header" :class="{'cr-header--catalog':isCatalog}">
      <div class="cr-header__wrapper">
        <div class="cr-header__left">
          <img v-if="showLogo" class="cr-header__logo-image" src="/assets/img/logo.png" width="72" height="30" alt="">
          <a v-if="showPrev" class="cr-header__back-link cr-icon-link simulated-hover" @click="prevPage" aria-label="Назад">
            <svg class="cr-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/img/svg/sprite.svg#arrow-line-left"></use>
            </svg>
          </a>
        </div>
        <div v-if="title" class="cr-header__middle">
          <div class="cr-header__title">
            {{ title }}
          </div>
        </div>
        <div v-if="showIcon" class="cr-header__right">
          <ul class="cr-header__tools-list">
            <li class="cr-header__tools-item">
              <router-link class="cr-icon-link simulated-hover" to="/notification/" aria-label="Уведомления">
                            <span v-if="counterPushData.length > 0" class="cr-icon-link__label">
                                {{ counterPushData.length }}
                            </span>
                <svg class="cr-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
                  <use xlink:href="/assets/img/svg/sprite.svg#icon-notification"></use>
                </svg>
              </router-link>
            </li>
            <li class="cr-header__tools-item">
              <router-link class="cr-icon-link simulated-hover" :to="isAuth?'/personal/':'/auth/'" aria-label="Уведомления">
                <svg class="cr-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
                  <use xlink:href="/assets/img/svg/sprite.svg#icon-user"></use>
                </svg>
              </router-link>
            </li>
          </ul>
        </div>
        <div v-if="showIconSearch" class="cr-header__right">
          <ul class="cr-header__tools-list">
            <li class="cr-header__tools-item">
              <button @click="openSearch = true" class="cr-icon-link simulated-hover" type="button" aria-label="Поиск">
                <svg class="cr-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
                  <use xlink:href="/assets/img/svg/sprite.svg#icon-search-1"></use>
                </svg>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="showSearch" class="cr-header__search">
      <SearchForm></SearchForm>
      </div>
    </header>
    <main>

      <router-view/>

      <FlyBasket v-if="isBasket !== true"></FlyBasket>
    </main>
    <nav class="cr-mobile-nav">
      <ul class="cr-mobile-nav__list">
        <li class="cr-mobile-nav__item">
          <router-link active-class="cr-mobile-nav__link--current" class="cr-mobile-nav__link simulated-hover" to="/">
                    <span class="cr-mobile-nav__icon-wrapper">
                        <svg class="cr-mobile-nav__icon" width="22" height="22" viewBox="0 0 22 23">
                            <use xlink:href="/assets/img/svg/sprite.svg#icon-home"></use>
                        </svg>
                    </span>
            Главная
          </router-link>
        </li>
        <li class="cr-mobile-nav__item">
          <router-link active-class="cr-mobile-nav__link--current" class="cr-mobile-nav__link simulated-hover" to="/catalog/">
                    <span class="cr-mobile-nav__icon-wrapper">
                        <svg class="cr-mobile-nav__icon" width="22" height="22" viewBox="0 0 22 23">
                            <use xlink:href="/assets/img/svg/sprite.svg#icon-menu"></use>
                        </svg>
                    </span>
            Каталог
          </router-link>
        </li>
        <li class="cr-mobile-nav__item">
          <router-link active-class="cr-mobile-nav__link--current" class="cr-mobile-nav__link simulated-hover" to="/category/new/">
                    <span class="cr-mobile-nav__icon-wrapper">
                        <svg class="cr-mobile-nav__icon" width="22" height="22" viewBox="0 0 22 23">
                            <use xlink:href="/assets/img/svg/sprite.svg#icon-stars"></use>
                        </svg>
                    </span>
            Новинки
          </router-link>
        </li>
        <li class="cr-mobile-nav__item">
          <router-link active-class="cr-mobile-nav__link--current" class="cr-mobile-nav__link simulated-hover" to="/category/sale/">
                    <span class="cr-mobile-nav__icon-wrapper">
                        <svg class="cr-mobile-nav__icon" width="22" height="22" viewBox="0 0 22 23">
                            <use xlink:href="/assets/img/svg/sprite.svg#icon-sale"></use>
                        </svg>
                    </span>
            Скидки
          </router-link>
        </li>
        <li class="cr-mobile-nav__item">
          <router-link active-class="cr-mobile-nav__link--current" class="cr-mobile-nav__link simulated-hover" to="/basket/">
                    <span class="cr-mobile-nav__icon-wrapper">
                      <span v-if="counterBasketData.count > 0" class="cr-mobile-nav__label">
                            {{ counterBasketData.count }}
                        </span>
                        <svg class="cr-mobile-nav__icon" width="22" height="22" viewBox="0 0 22 23">
                            <use xlink:href="/assets/img/svg/sprite.svg#icon-cart"></use>
                        </svg>
                    </span>
            Корзина
          </router-link>
        </li>
        <li class="cr-mobile-nav__item">
          <router-link active-class="cr-mobile-nav__link--current" class="cr-mobile-nav__link simulated-hover" :to="isAuth?'/personal/':'/personalnotauth/'">
                    <span class="cr-mobile-nav__icon-wrapper">
                        <svg class="cr-mobile-nav__icon" width="22" height="22" viewBox="0 0 22 23">
                            <use xlink:href="/assets/img/svg/sprite.svg#icon-user-1"></use>
                        </svg>
                    </span>
            Профиль
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import SearchForm from '../views/components/SearchForm.vue';
import FlyBasket from "@/views/components/FlyBasket.vue";

export default {
  data: () => ({
    openSearch: false
  }),
  created() {
    this.fetchCounterData();
  },
  watch: {
    '$route.path'() {
      this.openSearch = false;
    }
  },
  computed: {
    ...mapGetters([
      'isAuth',
    ]),
    ...mapGetters('counter', [
      'counterBasketData',
        'counterPushData'
    ]),
    ...mapGetters('products', [
      'section'
    ]),
    ...mapGetters('order_detail', [
      'order'
    ]),
    ...mapGetters('page', [
      'page'
    ]),
    title() {
      if (this.$route.path.indexOf('/category/') != -1 && this.section && this.section.hasOwnProperty('name')) {
        return this.section.name;
      }
      if (this.$route.name == 'orderDetail' && this.order && this.order.hasOwnProperty('id'))
      {
        return 'Заказ №'+this.order.number;
      }
      if (this.$route.name == 'page' && this.page && this.page.hasOwnProperty('name'))
      {
        return this.page.name;
      }
      return this.$route.meta.name;
    },
    showLogo() {
      return this.$route.meta.main_page;
    },
    showIcon() {
      return this.$route.meta.main_page;
    },
    showIconSearch() {
      return this.$route.meta.category_page;
    },
    isMain() {
      return this.$route.meta.main_page;
    },
    isCatalog() {
      return this.$route.meta.catalog_page;
    },
    isBasket() {
      return this.$route.meta.basket_page;
    },
    showPrev() {
      return this.$route.meta.show_prev;
    },
    showSearch() {
      return this.isMain || this.$route.query.q || this.openSearch;
    }
  },
  components: {SearchForm, FlyBasket},
  methods: {
    ...mapActions('counter', [
      'fetchCounterData'
    ]),
    prevPage() {
      this.$router.go(-1)
    },
  },
}
</script>
